<template>
  <p class="text-[#8e9596] text-sm font-thin mb-5">Send me emails about:</p>
  <div class="flex flex-col gap-2.5">
    <Checkbox
      v-model:checked="isUserSubscribed"
      @update:checked="toggleSubscribe"
      >New features and updates</Checkbox
    >
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import Checkbox from '@ui/components/Checkbox.vue';

export default {
  components: {
    Checkbox,
  },

  setup() {
    const store = useStore();

    const isUserSubscribed = computed(
      () => store.getters['user/account/getIsSubscribed']
    );

    return {
      isUserSubscribed,
    };
  },

  methods: {
    async toggleSubscribe(checked) {
      try {
        const response = await this.$store.dispatch(
          'user/account/updateSubscribedToNewsletter',
          {
            value: checked,
          }
        );

        const { message } = response.data;

        this.$store.dispatch('application/notifications/createInfo', {
          text: message,
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
